import { createStore, combineReducers } from "redux";
import QuestionReducer from "./reducers/question";

const reducers = combineReducers({
  question: QuestionReducer,
});

export default createStore(reducers);
